import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'
import { callApi } from '../helpers/methods'
import { isBlank } from '../helpers/stringHelper'
import { getToken } from '../store/auth';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Return, SelectCentroCusto, Select } from '../components/inspinia';
import UrlCampanhaSms from '../components/campanhaSms/urlCampanhaSms';
//LAYOUT
import PrivateLayout from '../layouts/private'

//MASK
import InputMask from 'react-input-mask';
import { SMS } from '../store/tipoListaEmail';
import { InputSharp } from '@material-ui/icons';

class EnvioSms extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state =
        {
            loading: false,
            form: this.formInitialState(),
            maxLength: "160",
            posicaomouse1: [],
            posicaomouse2: [],
            comboEmpresa:
            {
                results: undefined
            },
            comboCentroCusto:
            {
                results: undefined
            },

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }
        this.handleChangeNome = this.handleChangeNome.bind(this);
        this.handleChangeTelefone = this.handleChangeTelefone.bind(this);
        this.handleChangeUrl = this.handleChangeUrl.bind(this);
        this.onClickCancelar = this.onClickCancelar.bind(this);
        this.handleEnviar = this.handleEnviar.bind(this);
        this.LoadEnvioSms = this.LoadEnvioSms.bind(this);
        this.handleTextArea = this.handleTextArea.bind(this);
        this.handleLimparPesquisa = this.handleLimparPesquisa.bind(this);
        this.handleChangeEmpresaCentroCusto = this.handleChangeEmpresaCentroCusto.bind(this);
        this.click = this.click.bind(this);
    }

    formInitialState() {
        return {
            nome: "",
            telefone: "",
            textoSms: "",
            url: "",
            empresa: {},
            centroCusto: {},
        }
    }

    componentDidMount() {
        this.loadComboEmpresa();
    }

    loadComboEmpresa() {
        let self = this
        const data = JSON.stringify({
            'id_produto': SMS
        });

        const url = `${c.API_BASE_URL}/company-user`;

        const options = {
            method: 'POST',
            body: data
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response });
        });
    }

    loadComboCentroCusto(idEmpresa) {
        let self = this;
        const url = `${c.API_BASE_URL}/centroCusto-empresa/${idEmpresa}`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        if (!this.isIdEmpresaVazio(idEmpresa)) {
            callApi(url, options, function (response) {
                self.setState({ ...self.state, loading: false, comboCentroCusto: response });
            });
        } else {
            self.setState({ ...self.state, loading: false, comboCentroCusto: { results: undefined } })
        }
    }

    isIdEmpresaVazio(idEmpresa) {
        return (isNaN(idEmpresa) || idEmpresa === undefined || idEmpresa === '' || idEmpresa === "")
    }

    handleChangeEmpresaCentroCusto(e) {
        this.click(e);
        const valor = e.target.value;
        const index = e.target.selectedIndex;
        const texto = e.target[index].text;
        let nome = e.target.name;
        if (nome === "empresa") {
            this.setState(prevState => {
                const inputs = { ...prevState.form };

                inputs.empresa.id = parseInt(valor);
                inputs.empresa.nome = texto;
                this.loadComboCentroCusto(inputs.empresa.id);
                return { inputs }
            });
        } else if (nome === "centroCusto") {

            this.setState(prevState => {
                const inputs = { ...prevState.form };

                inputs.centroCusto.id = parseInt(valor);
                inputs.centroCusto.nome = texto;
                return { inputs }
            });
        }
    }

    click(campo) {
        var startPos = campo.target.selectionStart;
        var endPos = campo.target.selectionEnd;
        this.setState({ posicaomouse1: startPos, posicaomouse2: endPos });
    }

    handleChangeNome(e) {
        this.click(e);
        var texto = e.target.value;
        this.state.form.nome = texto;
    }

    handleChangeTelefone(e) {
        this.click(e);
        var numeroTelefone = e.target.value;
        this.state.form.telefone = numeroTelefone;
    }

    handleChangeUrl(e) {
        this.click(e);
        var urlInput = e.target.value;
        this.state.form.url = urlInput;
    }

    handleTextArea(e) {
        this.click(e);
        var textArea = e.target.value;
        this.state.form.textoSms = textArea;

        this.validacaoLimiteTextArea();
    }

    validacaoLimiteTextArea() {
        var url = this.state.form.url;
        if (!url) {
            this.setState({ maxLength: "160" });
        } else {
            this.setState({ maxLength: "135" });
        }
    }

    onClickCancelar() {
        this.setState({
            ...this.state,
            form: {
                nome: "",
                telefone: "",
                textoSms: "",
                url: ""
            },
        });
    }

    handleEnviar(e) {
        this.LoadEnvioSms(e);
    }

    LoadEnvioSms(e) {
        e.preventDefault();
        let self = this;
        const url = `${c.API_BASE_URL}/envio-sms`;

        const form = this.state.form;

        if (!this.validacaoTelefone(form.telefone)) {
            return;
        }

        if (form.empresa.id == undefined || form.empresa.nome === "Selecione...") {
            c.TOASTER_INFO("Preenchimento de empresa obrigatório.");
            return;
        }

        if (form.centroCusto.id == undefined || form.centroCusto.nome === "Selecione...") {
            c.TOASTER_INFO("Preenchimento de centro de custo obrigatório.");
            return;
        }

        if (form.textoSms == '') {
            c.TOASTER_INFO("Preenchimento do corpo do texto SMS obrigatório.");
            return;
        }

        self.setState({ ...self.state, loading: true });

        const _token = c.AUTH_HEADER(getToken());

        const options = {
            method: 'POST'
            , headers: { 'Content-Type': 'application/json', 'Authorization': _token }
            , body: JSON.stringify({
                nome: this.state.form.nome,
                telefone: this.state.form.telefone,
                textoSms: this.state.form.textoSms,
                url: this.state.form.url,
                centroCusto: { id: form.centroCusto.id },
                empresa: {
                    id: form.empresa.id,
                    nome: form.empresa.nome
                }
            })
        };

        fetch(url, options).then(async(response) => {
          let json = await response.json();

          if (response.ok) {
            self.handleLimparPesquisa();
            c.TOASTER_SUCCESS(json.message);
          } else {
            c.TOASTER_ERROR(json.message);
          }
          self.setState({ ...self.state, loading: false });
        }).catch((exception) => {
            console.log("fetch error" + exception);
            self.setState({ ...self.state, loading: false });
            c.TOASTER_ERROR("Erro ao enviar mensagem.");
        });
    }

    validacaoTelefone(telefone) {
        if (telefone == '') {
            c.TOASTER_INFO("Preenchimento de telefone obrigatório.");
            return false;
        }

        if (telefone != '' && telefone.match('\d')) {
            c.TOASTER_INFO("Telefone deve conter somente numeros");
            return false;
        }

        if (telefone != '' && telefone.length < 11 || telefone.length > 11) {
            c.TOASTER_INFO("Telefone deve ter 11 digitos");
            return false;
        }

        return true;
    }

    handleLimparPesquisa() {
        this.setState({
            ...this.state, form: {
                id: "",
                nome: "",
                telefone: "",
                textoSms: "",
                url: "",
                empresa: {},
                centroCusto: {}
            }
        });
    }



    render() {
        const form = this.state.form;
        return (
            <PrivateLayout navActiveItem={c.NAV_PANEL}>
                <div>
                    <Row className="mb-4">
                        <Column size="3">
                            <h2 className="fs-20 fw-600 text-body m-0">Envio de mensagem SMS</h2>
                        </Column>
                    </Row>
                    <Row className="mb-3">
                        <Column size="9">
                            <IBox className="mb-0">
                                <div className='form-group col-md-6'>
                                    <label>Nome</label>
                                    <div>
                                        <input type="text" className='form-control m-b' onChange={this.handleChangeNome} value={this.state.form.nome}></input>
                                    </div>
                                </div>
                                <br />
                                <div className='form-group col-md-6'>
                                    <label>Telefone</label>
                                    <div>
                                        <input type='text' className='form-control m-b' onChange={this.handleChangeTelefone} value={this.state.form.telefone}></input>
                                    </div>
                                </div>
                                <div className="form-group col-md-6">
                                    <Select name="empresa" selected={form.empresa.id} data={this.state.comboEmpresa} onChange={this.handleChangeEmpresaCentroCusto} placeholder="Empresa" />
                                </div>
                                <div className="form-group col-md-6">
                                    <SelectCentroCusto name="centroCusto" selected={form.centroCusto.id} data={this.state.comboCentroCusto} onChange={this.handleChangeEmpresaCentroCusto} placeholder="Centro de Custo" />
                                </div>
                                <div className='form-group col-md-6'>
                                    <label className='mt-3'>Corpo do texto SMS</label>
                                    <div className="form-group">
                                        <textarea className='form-control m-b' rows="12" cols="50" maxLength={this.state.maxLength} value={this.state.form.textoSms} onChange={this.handleTextArea} onClick={this.click} />
                                        <small className="form-text text-muted"><i className="fa fa-info-circle" style={{ fontSize: "15px" }}></i><br />A quantidade máxima de caracteres será determinada pela inserção da url.<br /><strong>Com URL: 135 caracteres. <br />Sem URL: 160 caracteres.</strong></small>
                                    </div>
                                </div>
                            </IBox>
                        </Column>
                        <Column size="3" className="container">
                            <Row>
                                <Column size="12" className="container">
                                    <UrlCampanhaSms onChange={this.handleChangeUrl} value={this.state.form.url} />
                                </Column>
                            </Row>
                        </Column>
                    </Row>
                    <Row>
                        <Column size="3">
                            <div className="form-group col-md-12 input-group">
                                <Return to={c.PANEL_ROUTE} className="mx-1" width="100px" />
                                <Button disabled={this.state.loading} className="mx-1" width="100px" onClick={this.handleEnviar}>Enviar</Button>
                            </div>
                        </Column>
                    </Row>
                </div>
            </PrivateLayout >
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch) {
    return { actions: {} };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnvioSms));
